module.exports = __webpack_public_path__ + "media/images/component/filter-527d850240caaa9f4a695c34bb463fd4.svg";